import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import { AppContext } from "./lib/contextLib";
import { onError } from "./lib/errorLib";
import AppRoutes from "./AppRoutes";
import { setNow } from "./time/actionCreators";
import { loadLogin } from "./user/actionCreators";
import { connect } from "react-redux";
import AppContainer from "AppContainer";

export type StateProps = {
  now: number;
  time: number;
};
export type DispatchProps = {
  loadLogin: () => void;
  setNow: (arg0: number) => void;
};
export type OwnProps = {};
export type Props = StateProps & DispatchProps & OwnProps;

function App(props: Props) {
  const nav = useNavigate();
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);

  const { loadLogin, setNow } = props;

  useEffect(() => {
    async function onLoad() {
      loadLogin();
      setNow(new Date().getTime());
      // TODO add an app state change handler to update the time
      try {
        await Auth.currentSession();
        userHasAuthenticated(true);
      } catch (e) {
        if (e !== "No current user") {
          onError(e);
        }
      }

      setIsAuthenticating(false);
    }

    onLoad();
  }, [loadLogin, setNow]);

  async function handleLogout() {
    await Auth.signOut();

    userHasAuthenticated(false);

    nav("/login");
  }

  function getNavigationStyle(pathname: string) {
    const isHabit =
      pathname.startsWith("/daily/") ||
      pathname.startsWith("/multiday/") ||
      pathname.startsWith("/site/");
    return isHabit ? "modal" : "nav";
  }

  return (
    !isAuthenticating && (
      <AppContainer
        navigationStyle={getNavigationStyle(window.location.pathname)}
        isAuthenticated={isAuthenticated}
        handleLogout={handleLogout}
      >
        <ErrorBoundary>
          <AppContext.Provider
            value={{ isAuthenticated, userHasAuthenticated }}
          >
            <AppRoutes />
          </AppContext.Provider>
        </ErrorBoundary>
      </AppContainer>
    )
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    time: state.time.time,
    now: state.time.now,
  };
};

const mapDispatchToProps = {
  loadLogin,
  setNow,
};

export default connect<Props, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(App);
